import { useEffect, useRef } from 'react';

/**
 * 指定された間隔で条件付きポーリングを行うフック
 * @param callback 実行するコールバック関数
 * @param intervalMs ポーリング間隔（ミリ秒）
 * @param condition trueの場合のみポーリングを実行する
 */
export function useConditionalPolling(
  callback: () => void,
  intervalMs: number,
  condition: boolean
) {
  const savedCallback = useRef(callback);

  // コールバックを常に最新の状態に保つ
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!condition) {
      return;
    }

    const tick = () => {
      savedCallback.current();
    };

    const id = setInterval(tick, intervalMs);
    
    return () => clearInterval(id);
  }, [intervalMs, condition]);
}
